import { colors } from "theme";
import { TOP_APP_BAR_HEIGHT } from "utils/constants";

export const styles = {
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 40,
    width: 28,
    borderRadius: 5,
    "&:hover": {
      backgroundColor: colors.gray[100],
    },
  },
  backdrop: {
    position: "fixed",
    zIndex: 10,
    top: TOP_APP_BAR_HEIGHT,
    height: `calc(100% - ${TOP_APP_BAR_HEIGHT}px)`,
    overflow: "auto",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
  selectArea: {
    position: "relative",
    width: 455,
    height: "100%",
    borderTop: `1px solid ${colors.gray[300]}`,
    padding: "0 23px 23px 23px",
    backgroundColor: colors.white,
    overflowY: "auto",
  },
  searchInput: {
    position: "sticky",
    paddingTop: 3,
    top: 0,
    backgroundColor: colors.white,
    zIndex: 1,
  },
  listItemRoot: {
    height: 48,
    "&:hover": {
      backgroundColor: "#00000014",
    },
  },
  inputBase: {
    paddingBottom: 1,
    paddingTop: 0.5,
  },
};
